'use strict';

var isPropertyDescriptor = require('./records/property-descriptor');

module.exports = function isFullyPopulatedPropertyDescriptor(ES, Desc) {
	return isPropertyDescriptor(Desc)
		&& typeof Desc === 'object'
		&& '[[Enumerable]]' in Desc
		&& '[[Configurable]]' in Desc
		&& (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isFullyPopulatedPropertyDescriptor.js
 ** module id = 933
 ** module chunks = 0
 **/